/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    SocialLoginMutation$data,
    SocialLoginMutation$variables,
    SocialLoginService
} from "mutation/__generated__/SocialLoginMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation SocialLoginMutation($input: SocialLoginInput!) {
        social_login(input: $input) {
            access_token
        }
    }
`;

export default async function SocialLogin(token: string, service: SocialLoginService) {
    const variables: SocialLoginMutation$variables = {
        input: {
            token: token,
            service: service,
            app: "Music"
        }
    }
    const output = await perform<SocialLoginMutation$data>(mutation, variables);
    return output.social_login.access_token;
}